import styled from 'styled-components';

export const ModalBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  color: ${(props) => props.theme.colors.errorDark};
  font-size: 12px;
  margin-top: 4px;
`;

